import React, { useEffect, useState } from 'react';
import { Code, Save, Eye, EyeOff, CheckCircle, AlertTriangle } from 'lucide-react';
import { useApi } from './DashboardLayout';

export default function MailSignaturePage() {
  const [html, setHtml] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const { apiFetch } = useApi();

  useEffect(() => { loadSignature(); }, []);

  const loadSignature = async () => {
    const r = await apiFetch('/api/settings/mail-signature');
    if (!r) return;
    try { const d = await r.json(); if (d) setHtml(d.html || ''); } catch {}
  };

  const showFb = (type, text) => { setFeedback({ type, text }); setTimeout(() => setFeedback(null), 5000); };

  const saveSignature = async () => {
    setSaving(true);
    try {
      const r = await apiFetch('/api/settings/mail-signature', { method: 'PUT', body: JSON.stringify({ html }) });
      if (!r) { setSaving(false); return; }
      const d = await r.json();
      if (d?.status) showFb('success', 'Signatur gespeichert.');
      else showFb('error', d?.detail || 'Fehler.');
    } catch (e) { showFb('error', e.message); }
    setSaving(false);
  };

  return (
    <div data-testid="mail-signature-page">
      <div className="page-header">
        <h2>Einstellungen</h2>
        <p>E-Mail-Signatur</p>
      </div>

      {feedback && (
        <div className={`design-feedback ${feedback.type}`} data-testid="signature-feedback">
          {feedback.type === 'success' ? <CheckCircle size={14} /> : <AlertTriangle size={14} />}
          {feedback.text}
        </div>
      )}

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div className="card-body">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <Code size={20} style={{ color: 'var(--text-secondary)' }} />
            <h4 style={{ fontSize: 16, fontWeight: 700 }}>HTML-Signatur</h4>
          </div>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 16 }}>
            Fügen Sie hier den HTML-Quellcode Ihrer E-Mail-Signatur ein. Dieser wird 1:1 unverändert unter jeder ausgehenden E-Mail eingefügt.
          </p>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
            <button type="button" onClick={() => setShowPreview(!showPreview)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 4 }} data-testid="signature-toggle-preview">
              {showPreview ? <><EyeOff size={14} /> Code anzeigen</> : <><Eye size={14} /> Vorschau</>}
            </button>
          </div>

          {showPreview ? (
            <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 16, minHeight: 150, background: '#fff' }} data-testid="signature-preview">
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          ) : (
            <textarea
              className="form-input"
              value={html}
              onChange={e => setHtml(e.target.value)}
              rows={16}
              style={{ fontFamily: 'monospace', fontSize: 13, resize: 'vertical', lineHeight: 1.5 }}
              placeholder='<table>...<br>  Ihr Signatur-HTML-Code hier einfügen<br>...</table>'
              data-testid="signature-html-input"
            />
          )}
        </div>
      </div>

      <button className="btn btn-primary" onClick={saveSignature} disabled={saving} data-testid="signature-save-btn">
        <Save size={14} /> Speichern
      </button>
    </div>
  );
}
